import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { addRole } from "./roleApis";

const AddRole = ({ onSuccess = null, inModal = false, onCancel = null }) => {
  const [loader, setLoader] = useState(false);
  const { Title } = Typography;
  const showCancel = Boolean(onCancel);

  const onFinish = async (values) => {
    setLoader(true);
    const resp = await addRole(values);
    if (resp.message === "success") {
      setLoader(false);
      if (inModal && onSuccess) onSuccess();
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = () => {
    toast.warning("Failed at adding role");
    setLoader(false);
  };

  const formContent = (
    <Form
      name="basic"
      labelCol={{ span: inModal ? 6 : 6 }}
      wrapperCol={{ span: inModal ? 18 : 12 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        style={{ marginBottom: "20px" }}
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input your username!" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        style={{ marginBottom: inModal ? 0 : "10px" }}
        wrapperCol={inModal ? { offset: 0, span: 24 } : { offset: 6, span: 12 }}
      >
        {inModal ? (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, width: "100%" }}>
            <Button
              onClick={() => setLoader(true)}
              type="primary"
              htmlType="submit"
              shape="round"
              loading={loader}
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
              block={!showCancel}
            >
              Add New Role
            </Button>
            {onCancel && (
              <Button
                type="primary"
                danger
                shape="round"
                onClick={onCancel}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        ) : (
          <Button
            onClick={() => setLoader(true)}
            type="primary"
            size="small"
            htmlType="submit"
            block
            loading={loader}
          >
            Add New Role
          </Button>
        )}
      </Form.Item>
    </Form>
  );

  if (inModal) return formContent;

  return (
    <Row className="mr-top">
      <Col xs={24} sm={24} md={24} lg={16} xl={12} className="column-design border rounded card-custom">
        <Title level={4} className="text-center" style={{ backgroundColor: "#dadada", padding: "10px", margin: "0 !important" }}>
          Add New Role
        </Title>
        {formContent}
      </Col>
    </Row>
  );
};

export default AddRole;
